// bug of old version of TS
// eslint-disable-next-line no-shadow
export enum storeModuleNames {
  MAP_FOR_ROUTES = 'mapForRoutes',
  ROUTES_PARAMS_STORE = 'routesParamsStore',
}

export const apiURL = '/';

export const endpoints = {
  intelligentSearch: 'intelligentSearch',
};

export const productTypes = {
  ALL: 'all',
  TOUR_OFFER: 'tourOffer',
  RAILWAY_TOUR: 'railwayTour',
  HOTEL_OFFER: 'hotelOffer',
};

export const operators = {
  MY_AGENT: [226, 299],
};

export const FOOTER_LINKS = [
  { text: 'Политика о персональных данных', url: '/privacy.html' },
  { text: 'Политика использования файлов cookie', url: '/cookies-agreement' },
  { text: 'Пользовательское соглашение', url: '/user-agreement.html' },
  { text: 'Cогласие на обработку персональных данных', url: '/personal-data-agreement.html' },
  { text: 'На сайте применяются рекомендательные технологии', url: '/recommendation-technologies-agreement' },
  { text: 'Согласие на получение рекламы', url: '/consent-to-advertising' },
  { text: 'Согласие на распространение', url: '/personal-data-transfer-consent.html' },
  { text: 'Согласие посетителя', url: '/personal-data-visitor-consent.html' },
] as const;
